import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import "./styles.css";

const TopStoriesCard = (props) => {
  const data = props?.data;

  return (
    <Link to={data?.url} target="_blank">
      <div className="rounded-[1.25em] border border-liteBoxBorder shadow-boxContainer flex">
        <div className="w-[15.625em] h-[12.5em] p-2 flex flex-col gap-3">
          <div className="text-red-600 font-medium">Education</div>
          <div
            className="text-[1em] font-semibold truncate-title"
            title={data?.title}
          >
            {data?.title}
          </div>
          <div className="text-medium text-[0.875em] opacity-80">
            {data?.publishedAt
              ? moment(data?.publishedAt).format("DD-MMM-YY")
              : ""}
          </div>
          <div
            className="text-medium text-[0.875em] opacity-80"
            title={data?.author}
          >
            {data?.author?.length > 50
              ? `${data?.author?.slice(0, 50)}...`
              : data?.author}
          </div>
        </div>
        <div className="h-[12.5em] w-[12.5em]">
          <img
            src={data?.urlToImage}
            className="h-full w-full object-cover rounded-r-[1.25em]"
          />
        </div>
      </div>
    </Link>
  );
};

export default TopStoriesCard;
